/**
 * NAVNEBYTTET CHORUS → TVITVI (oktober 2026): `chorus.*` i nettleserlagringen blir `tvitvi.*`.
 *
 * Ingen skal logges ut og ingen innstilling skal forsvinne. Sesjonen (`chorus.auth`), det aktive
 * huset, temaet og resten flyttes derfor ÉN gang, før noe leser dem: en nøkkel kopieres bare når
 * den nye ikke finnes fra før, og den gamle fjernes etterpå. Feiler en skriving (privat modus,
 * full kvote), blir den gamle stående, og neste innlasting prøver igjen.
 *
 * To steder kjører dette, med de samme reglene: innebygd i `index.html` (temaet leses der, før
 * første maling) og `legacy-storage-boot.ts`, den første importen i `main.tsx`, før Supabase-
 * klienten lages. `legacy-storage.test.ts` kjører begge og holder dem like.
 */
export const LEGACY_STORAGE_PREFIX = 'chorus.';
export const STORAGE_PREFIX = 'tvitvi.';

/** Flytter hver `chorus.*`-nøkkel i én lagring. Svarer med hvor mange som ble flyttet. */
export function migrateLegacyKeys(store: Storage): number {
  const legacy: string[] = [];
  for (let index = 0; index < store.length; index += 1) {
    const key = store.key(index);
    if (key !== null && key.startsWith(LEGACY_STORAGE_PREFIX)) legacy.push(key);
  }
  for (const key of legacy) {
    const next = STORAGE_PREFIX + key.slice(LEGACY_STORAGE_PREFIX.length);
    const value = store.getItem(key);
    if (value !== null && store.getItem(next) === null) store.setItem(next, value);
    store.removeItem(key);
  }
  return legacy.length;
}

/** Begge lagringene. En blokkert lagring er en lagring uten noe å flytte, ikke en feil. */
export function migrateLegacyStorage(): void {
  for (const pick of [() => window.localStorage, () => window.sessionStorage]) {
    try {
      migrateLegacyKeys(pick());
    } catch {
      /* Privat modus eller full kvote: den gamle nøkkelen blir stående til neste gang. */
    }
  }
}
